"use strict";

exports.__esModule = true;
var _PredefinedCommentsContext = require("./PredefinedCommentsContext");
Object.keys(_PredefinedCommentsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PredefinedCommentsContext[key]) return;
  exports[key] = _PredefinedCommentsContext[key];
});
var _PredefinedCommentsController = require("./PredefinedCommentsController");
Object.keys(_PredefinedCommentsController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PredefinedCommentsController[key]) return;
  exports[key] = _PredefinedCommentsController[key];
});